import {
	BooleanButtonsInput,
	BooleanField,
	BooleanFieldInputProps,
	TextAreaInput,
	TextField,
	TextFieldInputProps,
} from "@hex-insights/forms";
import { StudentOTCMedicationFormValues } from "../../FormUtilities";
import { MedicationSelectField } from "../Medication";
import { BaseFieldProps } from "../shared";
import { StudentSelectField } from "../Student";

/**
 * Generic props for fields of the StudentOTCMedication model.
 */
type FieldProps<K extends keyof StudentOTCMedicationFormValues.Base = keyof StudentOTCMedicationFormValues.Base> =
	BaseFieldProps<Pick<StudentOTCMedicationFormValues.Base, K>>;

/**
 * Field component for the `isAllowed` field of the StudentOTCMedication model.
 */
export function IsAllowed({
	formState,
	label = "Is the student allowed to take this medication?",
	...props
}: FieldProps<"isAllowed">) {
	return (
		<BooleanField
			formState={formState}
			name="isAllowed"
			label={label}
			Input={IsAllowedInput}
			oneLine={false}
			{...props}
		/>
	);
}

function IsAllowedInput(props: BooleanFieldInputProps) {
	return <BooleanButtonsInput {...props} trueLabel="Allowed" falseLabel="Not Allowed" />;
}

/**
 * Field component for the `notes` field of the StudentOTCMedication model.
 */
export function Notes({ formState, ...props }: FieldProps<"notes">) {
	return <TextField formState={formState} name="notes" multiLine optional Input={NotesInput} {...props} />;
}

function NotesInput(props: TextFieldInputProps) {
	return <TextAreaInput minRows={2} {...props} />;
}

export namespace Medication {
	export type SelectProps = FieldProps<"medicationID"> &
		Omit<MedicationSelectField.SelectProps<StudentOTCMedicationFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `medication` edge of the StudentOTCMedication model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <MedicationSelectField.Select formState={formState} name="medicationID" {...props} />;
	}
}

export namespace Student {
	export type SelectProps = FieldProps<"studentID"> &
		Omit<StudentSelectField.SelectProps<StudentOTCMedicationFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `student` edge of the StudentOTCMedication model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentSelectField.Select formState={formState} name="studentID" {...props} />;
	}
}
